import { Text } from "components/Typography/text.styled";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import i18n from "services/translation/i18n";

interface TermsWebLinkProps {
  linkName: string;
  selectedTerms: string;
  color?: Color;
  bold?: boolean;
  link: string;
}

export const TermsWebLink: React.FC<TermsWebLinkProps> = ({
  selectedTerms,
  linkName,
  color = Color.SeaBlue600,
  bold = false,
  link,
}) => (
  <Text
    fontSize={FontSize.Small}
    fontFamily={
      bold ? FontFamily.MontserratSemiBold : FontFamily.MontserratRegular
    }
    color={color}
    cursor={true}
    onClick={() => {
      const lang = i18n.language;
      window.open(link);
    }}
  >
    {linkName}
  </Text>
);
